import * as React from "react"
import {
  type ActionBadgeProps,
  type BadgeProps,
  ActionBadge as BaseActionBadge,
  Badge as BaseBadge,
  badgeVariants,
} from "../ui/badge"

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>((props, ref) => {
  return <BaseBadge {...props} ref={ref} />
})

export const ActionBadge = React.forwardRef<HTMLButtonElement, ActionBadgeProps>((props, ref) => {
  return <BaseActionBadge {...props} ref={ref} />
})

Badge.displayName = "Badge"
ActionBadge.displayName = "ActionBadge"

export { badgeVariants }
export type { BadgeProps, ActionBadgeProps }
